import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { Plus } from 'lucide-react'

const NewPathwayButton = ({ hasProFeatures, showModal }) => {
  return (
    !hasProFeatures ? (
      <Tooltip>
        <TooltipTrigger className='cursor-not-allowed'>
          <Button
            id='new-pathway-button'
            disabled
            onClick={showModal}
          >
            New pathway
            <Plus size={16} />
          </Button>
        </TooltipTrigger>
        <TooltipContent>Upgrade to pro</TooltipContent>
      </Tooltip>
    ) : (
      <Button
        id='new-pathway-button'
        onClick={showModal}
      >
        New pathway
        <Plus size={16} />
      </Button>
    )
  )
}

export default NewPathwayButton
